/** A control still waiting on its access check, as `gateControlProps` marks it (F-0533 KD-5). */
export const GATE_PENDING_SELECTOR = "[aria-disabled='true'][aria-busy='true']";
